import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./ResearchArticle.css";

function parseMarkdown(raw) {
  const frontmatterMatch = raw.match(/^---\n([\s\S]*?)\n---\n?/);
  let body = raw;
  const meta = {};

  if (frontmatterMatch) {
    body = raw.replace(frontmatterMatch[0], "");

    frontmatterMatch[1].split("\n").forEach((line) => {
      const [key, ...rest] = line.split(":");

      if (key && rest.length) {
        meta[key.trim()] = rest.join(":").trim().replace(/^["']|["']$/g, "");
      }
    });
  }

  return { meta, body };
}

function renderMarkdown(body) {
  return body
    .split("\n")
    .map((line, index) => {
      const trimmed = line.trim();
      if (!trimmed) return null;

      if (trimmed.startsWith("# ")) {
        return <h1 key={index}>{trimmed.replace("# ", "")}</h1>;
      }

      if (trimmed.startsWith("## ")) {
        return <h2 key={index}>{trimmed.replace("## ", "")}</h2>;
      }

      if (trimmed.startsWith("### ")) {
        return <h3 key={index}>{trimmed.replace("### ", "")}</h3>;
      }

      return <p key={index}>{trimmed}</p>;
    })
    .filter(Boolean);
}

export default function KeyFigureArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadArticle() {
      setArticle(null);
      setError("");

      try {
        const response = await fetch(`/content/key-figures/${slug}.md`);

        if (!response.ok) {
          setError(`No key figure found for: ${slug}`);
          return;
        }

        const raw = await response.text();
        setArticle(parseMarkdown(raw));
      } catch (err) {
        console.error(err);
        setError("The key figure profile could not be loaded.");
      }
    }

    loadArticle();
  }, [slug]);

  if (error) {
    return (
      <main className="report-page">
        <article className="report-card">
          <p className="report-back">
            <Link to="/timeline">← Back to timeline</Link>
          </p>

          <h1>Profile not found</h1>
          <p>{error}</p>
        </article>
      </main>
    );
  }

  if (!article) {
    return (
      <main className="report-page">
        <article className="report-card">
          <p>Loading profile…</p>
        </article>
      </main>
    );
  }

  const title = article.meta.title || "Key Figure";
  const year = article.meta.year || "";

  return (
    <main className="report-page">
      <article className="report-card">
        <p className="report-back">
          <Link to="/timeline">← Back to timeline</Link>
        </p>

        {year && <p className="report-year">{year}</p>}

        <h1 className="report-main-title">{title}</h1>

        <div className="report-content">{renderMarkdown(article.body)}</div>
      </article>
    </main>
  );
}